import { isDefined } from '../../../../ts-utils';
import { defaultReactionsInMenu, mainReactionCode, resolveMainReactionName, } from '../default-reactions';
import { getReactionCode } from './reaction-converters';
export const getValidReactions = (reactions, config) => {
    var _a;
    const validReactionNames = ((_a = config.emotions) !== null && _a !== void 0 ? _a : defaultReactionsInMenu).filter(isDefined);
    const validReactionCodes = [
        ...validReactionNames.map((n) => getReactionCode(n, resolveMainReactionName(config.mainEmotion))),
        mainReactionCode,
    ];
    return reactions.filter((r) => validReactionCodes.includes(r.reactionCode));
};
//# sourceMappingURL=get-valid-reactions.js.map